import React from 'react';
import { View, StyleSheet, FlatList, ListRenderItemInfo } from 'react-native';
import { Text } from 'exoflex';

import { Card, Chart } from '../core-ui';
import { COLOR_ARRAY_BILL, CARD } from '../constants/colors';
import { formatDollar } from '../helpers/currencyFormat';

type InputArray = {
  key: string;
  value: number;
  currency: string;
};

type Props = {
  data: Array<InputArray>;
};

let renderListBill = ({ index, item }: ListRenderItemInfo<InputArray>) => (
  <View style={styles.listContainer}>
    <View style={styles.bulletContainer}>
      <View
        style={[styles.bullet, { backgroundColor: COLOR_ARRAY_BILL[index] }]}
      />
    </View>
    {formatDollar(item.value, item.currency).length > 10 ? (
      <Text style={styles.listText}>
        {item.key}
        {`\n${formatDollar(item.value, item.currency)}`}
      </Text>
    ) : (
      <Text style={styles.listText}>
        {item.key}
        {`${formatDollar(item.value, item.currency)}`}
      </Text>
    )}
  </View>
);

export default function BillCard({ data }: Props) {
  return (
    <Card style={styles.cardShadow}>
      <Card.Header style={styles.cardHeader}>
        <Text weight="medium" style={styles.textHeader}>
          Billing
        </Text>
      </Card.Header>
      <Card.Content>
        <View style={styles.chartContainer}>
          <Chart type="Doughnut" data={data} size={152} />
        </View>
        <View style={styles.flatListContainer}>
          <FlatList
            data={data}
            keyExtractor={(_, index) => index.toString()}
            renderItem={renderListBill}
          />
        </View>
      </Card.Content>
    </Card>
  );
}

const styles = StyleSheet.create({
  cardShadow: {
    shadowColor: CARD.shadow.NORMAL,
    shadowOpacity: 0.05,
  },
  cardHeader: {
    alignSelf: 'flex-start',
  },
  textHeader: {
    fontSize: 16,
  },
  chartContainer: {
    paddingHorizontal: 40,
    marginBottom: 24,
  },
  flatListContainer: {
    marginBottom: 10,
  },
  listContainer: {
    flexDirection: 'row',
    marginBottom: 2,
    padding: 10,
    paddingVertical: 6,
  },
  bulletContainer: {
    justifyContent: 'center',
    alignContent: 'center',
    marginRight: 12,
  },
  bullet: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },
  listText: {
    fontSize: 14,
  },
});
